"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NHSCourseCarePackagesSnapshot_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var NHSCourseSnapshot_1 = require("./NHSCourseSnapshot");
var NHSCourseCarePackagesSnapshot_Factory = /** @class */ (function () {
    function NHSCourseCarePackagesSnapshot_Factory() {
    }
    NHSCourseCarePackagesSnapshot_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            CarePackageId: model.CarePackageId,
            ChargeExempt: model.ChargeExempt,
            NHSCourseSnapshot: NHSCourseSnapshot_1.NHSCourseSnapshot_Factory.CreateIncoming(model.NHSCourseSnapshot),
            NHSCourseSnapShotId: model.NHSCourseSnapShotId,
            OrigTxUrgent: model.OrigTxUrgent,
            Qty: model.Qty,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    NHSCourseCarePackagesSnapshot_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            CarePackageId: model.CarePackageId,
            ChargeExempt: model.ChargeExempt,
            NHSCourseSnapshot: NHSCourseSnapshot_1.NHSCourseSnapshot_Factory.CreateOutgoing(model.NHSCourseSnapshot),
            NHSCourseSnapShotId: model.NHSCourseSnapShotId,
            OrigTxUrgent: model.OrigTxUrgent,
            Qty: model.Qty,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    return NHSCourseCarePackagesSnapshot_Factory;
}());
exports.NHSCourseCarePackagesSnapshot_Factory = NHSCourseCarePackagesSnapshot_Factory;
